import { useState } from "react";
import { useCreateMeeting } from "@/hooks/useMeetings";

export function CreateMeetingModal({ onClose }: { onClose: () => void }) {
  const createMut = useCreateMeeting();
  const [title, setTitle] = useState("Meeting");
  const [guestEmail, setGuestEmail] = useState("");
  const [guestName, setGuestName] = useState("");
  const [startLocal, setStartLocal] = useState("");
  const [durationMin, setDurationMin] = useState(30);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    if (!startLocal) {
      setError("Start time is required");
      return;
    }
    const startAt = new Date(startLocal).toISOString();
    const endAt = new Date(
      new Date(startLocal).getTime() + durationMin * 60_000,
    ).toISOString();
    try {
      await createMut.mutateAsync({
        title,
        startAt,
        endAt,
        guests: guestEmail
          ? [{ email: guestEmail.trim(), name: guestName.trim() || undefined }]
          : [],
        leadName: guestName.trim() || undefined,
        syncToCalendar: true,
      });
      onClose();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Create failed");
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <form
        onSubmit={submit}
        className="w-full max-w-md space-y-4 rounded-lg border border-border bg-background p-5 shadow-lg"
      >
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold">Schedule meeting</h2>
          <button
            type="button"
            onClick={onClose}
            className="text-sm text-muted-foreground hover:text-foreground"
          >
            Close
          </button>
        </div>

        <label className="block text-sm">
          <span className="text-muted-foreground">Title</span>
          <input
            required
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="mt-1 w-full rounded-md border border-border bg-background px-3 py-2"
          />
        </label>

        <label className="block text-sm">
          <span className="text-muted-foreground">Start</span>
          <input
            type="datetime-local"
            required
            value={startLocal}
            onChange={(e) => setStartLocal(e.target.value)}
            className="mt-1 w-full rounded-md border border-border bg-background px-3 py-2"
          />
        </label>

        <label className="block text-sm">
          <span className="text-muted-foreground">Duration (minutes)</span>
          <input
            type="number"
            min={5}
            value={durationMin}
            onChange={(e) => setDurationMin(Number(e.target.value) || 30)}
            className="mt-1 w-full rounded-md border border-border bg-background px-3 py-2"
          />
        </label>

        <label className="block text-sm">
          <span className="text-muted-foreground">Guest name</span>
          <input
            value={guestName}
            onChange={(e) => setGuestName(e.target.value)}
            className="mt-1 w-full rounded-md border border-border bg-background px-3 py-2"
          />
        </label>

        <label className="block text-sm">
          <span className="text-muted-foreground">Guest email</span>
          <input
            type="email"
            value={guestEmail}
            onChange={(e) => setGuestEmail(e.target.value)}
            className="mt-1 w-full rounded-md border border-border bg-background px-3 py-2"
          />
        </label>

        {error && <p className="text-sm text-destructive">{error}</p>}

        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="rounded-md border border-border px-3 py-1.5 text-sm"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={createMut.isPending}
            className="rounded-md bg-brand px-3 py-1.5 text-sm font-medium text-brand-foreground disabled:opacity-60"
          >
            {createMut.isPending ? "Saving…" : "Schedule"}
          </button>
        </div>
      </form>
    </div>
  );
}
